export default {
	label: 'Jira',
	export: 'Export',
	sync: 'Sync',
	import: 'Import',
	exportCompleted: 'Exporting is finished.',
	importCompleted: 'Importing is finished.',
	actionProgress: 'Jira action is in progress. Please wait!',
	importProgress: 'Jira import is in progress. Please wait!',
	issuesToImport: 'Instance {instance} has {count} Jira issues left to import.',
	standardUpgradeIssues: 'Instance {instance} has {count} Jira issues being updated currently, due to standard update.',
	exportingIssues: 'Exporting measures to Jira, please wait.',
	isAnotherError: 'There seems to be an error creating Jira issues, please take a look at the logs.',
	deleteCompleted: 'Issue deletion is finished.',
	deleteInProgress: 'Issue deletion is in progress, please wait.',
	confirmIssueDelete: 'Are you sure you want to delete these issues from Jira?',
	status: {
		label: 'Status',
		isInitialized: 'Initialized',
		notInitialized: 'Not initialized',
		adminRightsMissing: 'Admin rights missing',
		noDomainConfig: 'No domain configuration',
		informationMissing: 'Information missing',
		taskUnsuccessful: 'An error occurred',
	},
	admin: 'Admin',
	domain: 'Domain',
	jiraInterface: 'Jira interface',
	addNewDomain: 'Add new domain',
	fieldIsRequired: 'Field is required!',
	invalidField: 'Invalid field!',
	invalidEmail: 'Email is not valid or missing!',
	invalidDomain: 'Domain is not valid or missing!',
	domainAdded: 'Domain added successfully!',
	domainsEdited: 'Domains edited successfully!',
	domainDeleted: 'Domain deleted successfully!',
	email: 'Email',
	apiToken: 'API token',
	limitExceededExport: 'You cannot export more than {count} measures at a time',
	limitExceededDelete: 'You cannot delete more than {count} measures at a time',
	goToSettings: 'Go to settings page',
	editDomain: 'Edit domains',
	methodNotExported: 'You cannot delete an measure that has not been exported to Jira.',
	methodSuccessfulCount: 'Successfully exported',
	methodUpdatedSuccessfulCount: 'Successfully updated existing measures',
	methodFailedCount: 'Failed exported measures',
	methodUpdatedFailedCount: 'Failed updated existing measures',
	failedMethods: 'Failed methods',
	chosenCheckboxesWillBeCleared:
		'Chosen checkboxes will be cleared after selecting OK, you can then select up to 50 measures to export to the Jira E-ITS project.',
	confirmDomainConfigDelete: 'Are you sure you want to delete this domain configuration?',
	fieldNames: {
		duedate: 'Due date',
		assignee: 'Assignee',
		reporter: 'Reporter',
	},
	permissionMissingDelete: 'Missing permission for deleting Jira issues!',
	permissionMissingExport: 'Missing permission for exporting Jira issues!',
	automaticImport: 'Automatic import',
	automaticInfoText:
		'If automatic import choice is active, then going to the measures page Jira issues are automatically imported, if there are changes. If the choice is not active, then for importing Jira issue changes "Import" button must be manually clicked.',
}
